import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BackToTop from "../components/BackToTop";
import "../css/Shipbuildingpage.css";
import { FaDownload } from "react-icons/fa";

const ShipbuildingPage = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const bannerSlides = [
    "/wp-content/uploads/2016/07/Shipbuilding 1.jpeg",
    "/wp-content/uploads/2016/07/Shipbuilding 2.JPG",
  ];

  useEffect(() => {
    const t = setInterval(
      () => setCurrentSlide((p) => (p + 1) % bannerSlides.length),
      3000,
    );
    return () => clearInterval(t);
  }, [bannerSlides.length]);

  const vesselsList = [
    {
      label: "Data Sheets of the 5000 DWT Eco Bulk Carrier",
      href: "/wp-content/uploads/2022/09/5000_DWT_Eco_Bulk_Carrier_1.pdf",
    },
    {
      label: "5757 DWT Cable Laying Vessel",
      href: "/wp-content/uploads/2019/08/CLV_scanned_Data_Sheet.pdf",
    },
    {
      label: "Multipurpose Platform Vessels",
      href: "/wp-content/uploads/2016/02/Multipurpose-Platform-Vessel.pdf",
    },
    {
      label: "Multipurpose Platform Supply Vessels",
      href: "/wp-content/uploads/2016/02/78M-Multipurpose-Platform-Supply-Vessel.pdf",
    },
    {
      label: "Platform/ROV Support Vessels",
      href: "/wp-content/uploads/2016/02/Platform-ROV-Support-Vessel.pdf",
    },
    {
      label: "80 T BP Anchor Handling Tug Supply Vessels",
      href: "/wp-content/uploads/2016/02/80T-BP-Anchor-Handling-Cum-Supply-Vessel.pdf",
    },
    {
      label: "140 T BP Anchor Handling Tug Supply Vessels",
      href: "/wp-content/uploads/2016/02/140T-BP-Anchor-Handling-Tug-Supply-Vessel.pdf",
    },
    {
      label: "200T BP Anchor Handling Tug Supply Vessel",
      href: "/wp-content/uploads/2018/06/200T-BP-Anchor-Handling-Tug-Supply-Vessel.pdf",
    },
    {
      label: "20T BP Berthing Tug",
      href: "/wp-content/uploads/2016/02/20T-BP-Berthing-Tug.pdf",
    },
    {
      label: "40T BP Berthing Tug",
      href: "/wp-content/uploads/2016/02/40T-BP-Berthing-Tug.pdf",
    },
    {
      label: "45T BP Berthing Tug",
      href: "/wp-content/uploads/2016/02/45T-BP-Berthing-Tug.pdf",
    },
    {
      label: "65T BP Berthing Tug",
      href: "/wp-content/uploads/2016/02/65T-BP-Berthing-Tug.pdf",
    },
    {
      label: "Fast Landing Craft",
      href: "/wp-content/uploads/2016/02/Fast-Landing-Craft.pdf",
    },
    {
      label: "26M Landing Craft",
      href: "/wp-content/uploads/2016/02/26M-Landing-Craft.pdf",
    },
    {
      label: "29M Landing Craft",
      href: "/wp-content/uploads/2016/02/29M-Landing-Craft.pdf",
    },
    {
      label: "30M Crew Boats",
      href: "/wp-content/uploads/2016/02/30M-Crew-Boat.pdf",
    },
    {
      label: "33.5M Crew Boats",
      href: "/wp-content/uploads/2016/02/33.5M-Crew-Boat.pdf",
    },
    {
      label: "80 Passenger Launch",
      href: "/wp-content/uploads/2018/06/80-Passenger-Launch.pdf",
    },
    {
      label: "150 Passenger Vessels",
      href: "/wp-content/uploads/2016/02/150-Passenger-Vessel.pdf",
    },
    {
      label: "250 Passenger Cum 100 T Cargo Vessels",
      href: "/wp-content/uploads/2016/02/250-Passenger-cum-100T-Cargo-Vessel.pdf",
    },
    {
      label: "400 Passenger Cum 250 Ton Cargo Vessels",
      href: "/wp-content/uploads/2016/02/400-Passenger-Cum-250T-Cargo-Vessel.pdf",
    },
    {
      label: "10T BP Harbour Tug",
      href: "/wp-content/uploads/2016/08/10T-BP-Harbour-Tug.pdf",
    },
    {
      label: "58T BP Tug Boat",
      href: "/wp-content/uploads/2016/08/58T-BP-Tug-Boat.pdf",
    },
    {
      label: "Coastal Surveillance Vessel",
      href: "/wp-content/uploads/2016/08/Coastal-Surveillance-Vessel.pdf",
    },
    {
      label: "Fire Fighting Vessel",
      href: "/wp-content/uploads/2016/08/Fire-Fighting-Vessel.pdf",
    },
    {
      label: "Steel Pilot Launches",
      href: "/wp-content/uploads/2016/02/Steel-Pilot-Launch.pdf",
    },
    {
      label: "13M Mooring Launches",
      href: "/wp-content/uploads/2016/02/13M-Mooring-Launch.pdf",
    },
    {
      label: "Split Hopper Barges",
      href: "/wp-content/uploads/2016/02/Split-Hopper-Barge.pdf",
    },
    { label: "Deck/ Water/ Cargo Barges", href: null },
  ];

  return (
    <>
      <Header />

      {/* ── Banner (470px, hesperiden dots) ── */}
      <section id="main-banner" className="sb-banner">
        {bannerSlides.map((src, i) => (
          <img
            key={i}
            src={src}
            alt="Shipbuilding"
            className={`sb-banner-img${i === currentSlide ? " active" : ""}`}
          />
        ))}
        <div className="sb-dots">
          {bannerSlides.map((_, i) => (
            <span
              key={i}
              className={`sb-dot${i === currentSlide ? " selected" : ""}`}
              onClick={() => setCurrentSlide(i)}
            />
          ))}
        </div>
      </section>

      {/* ── Body – mirrors .contentwrapper > .content ── */}
      <section className="contentwrapper clearfix">
        <div className="content clearfix">
          {/* Breadcrumb */}
          <div className="breadcrumbs">
            <Link to="/">Home</Link> &gt; <span>Shipbuilding</span>
          </div>

          <h1 data-aos="fade-right">Shipbuilding</h1>

          {/* ── Row 1: text left (col-sm-6) + image right (col-sm-6) ── */}
          <div className="sb-two-cols">
            <div className="sb-col-half sb-col-text" data-aos="fade-right">
              <p>
                Colombo Dockyard's shipbuilding activities commenced in 1974
                with the construction of small tug boats, patrol boats, and
                barges which are now an important revenue source for the
                company.
              </p>
              <p>
                The company has been successful in securing orders from both
                local and overseas clients by competing with leading
                shipbuilders worldwide and is now in an enviable position
                rivalling shipbuilding yards that specialize in the construction
                of high powered and complex tug boats as well as aluminium
                hulled high speed boats which are a part of our wide spectrum of
                shipbuilding capacity.
              </p>
              <p>
                We have been actively involved in building a spectrum of vessels
                with varied characteristics for both local and international
                clients.
              </p>
            </div>

            <div className="sb-col-half sb-col-img" data-aos="fade-left">
              <figure className="sb-figure">
                <img
                  src="/wp-content/uploads/2016/02/Rachna.jpg"
                  alt="Rachna vessel"
                />
              </figure>
            </div>
          </div>

          {/* ── Full-width parallax row: vessels list ── */}
          <div
            className="sb-vessels-row"
            style={{
              backgroundImage:
                'url("/wp-content/uploads/2016/02/Ship-Under-Construction.jpg")',
            }}
          >
            <div className="sb-vessels-panel">
              {/* col-sm-6 white box */}
              <div className="sb-vessels-box white-box">
                <p>
                  <strong>Vessels built include,</strong>
                </p>
                <ul className="sb-vessels-list">
                  {vesselsList.map((v, i) =>
                    v.href ? (
                      <li key={i} data-aos="fade-right" data-aos-delay={i * 50}>
                        <a
                          href={v.href}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="dwnload-icon-blue"
                        >
                          {v.label}
                          <FaDownload className="download-icon" />
                        </a>
                      </li>
                    ) : (
                      <li key={i} data-aos="fade-right" data-aos-delay={i * 50}>{v.label}</li>
                    ),
                  )}
                </ul>
              </div>
            </div>
          </div>

          {/* ── Row 3: image left (col-sm-6) + text right (col-sm-6) ── */}
          <div className="sb-two-cols sb-two-cols--bottom">
            <div className="sb-col-half sb-col-img" data-aos="fade-right">
              <figure className="sb-figure">
                <img
                  src="/wp-content/uploads/2016/02/DSC_1018-2.jpg"
                  alt="Ship under construction"
                />
              </figure>
            </div>

            <div className="sb-col-half sb-col-text" data-aos="fade-left">
              <p>
                The company's ability to carry out the construction of these
                vessels to meet the requirements stipulated by stringent
                international Classification Societies, whilst customizing the
                vessel to surpass all stated and implied requirements of the
                customer, has paved the way for the company's stupendous growth
                in the Shipbuilding Sector.
              </p>
            </div>
          </div>
        </div>
        {/* .content */}
      </section>

      <Footer />
      <BackToTop />
    </>
  );
};

export default ShipbuildingPage;
